// mobile menu
const menuToggle = document.getElementById('menuToggle');
const navLinks = document.getElementById('navLinks');
const menuIconOpen = '<path d="M3 6h18M3 12h18M3 18h18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>';
const menuIconClose = '<path d="M5 5l14 14M19 5L5 19" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>';
let menuLastFocused = null;
function menuKeydown(e){
  if(!navLinks) return;
  if(e.key === 'Escape'){ e.preventDefault(); closeMobileMenu(); return; }
  if(e.key !== 'Tab') return;
  const focusable = getFocusable(navLinks);
  if(!focusable.length) return;
  const first = focusable[0], last = focusable[focusable.length - 1];
  if(e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
  else if(!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
}
function menuOutsideClick(e){
  if(!navLinks || navLinks.contains(e.target) || menuToggle.contains(e.target)) return;
  closeMobileMenu();
}
function openMobileMenu(){
  if(!navLinks || navLinks.classList.contains('open')) return;
  menuLastFocused = document.activeElement;
  navLinks.classList.add('open');
  menuToggle.setAttribute('aria-expanded', 'true');
  menuToggle.setAttribute('aria-label', 'Close menu');
  const icon = menuToggle.querySelector('svg');
  if(icon) icon.innerHTML = menuIconClose;
  document.querySelectorAll('main, footer').forEach(el => { el.inert = true; });
  document.addEventListener('keydown', menuKeydown);
  document.addEventListener('click', menuOutsideClick, true);
  const focusable = getFocusable(navLinks);
  (focusable[0] || navLinks).focus();
}
function closeMobileMenu(){
  if(!navLinks || !navLinks.classList.contains('open')) return;
  navLinks.classList.remove('open');
  menuToggle.setAttribute('aria-expanded', 'false');
  menuToggle.setAttribute('aria-label', 'Open menu');
  const icon = menuToggle.querySelector('svg');
  if(icon) icon.innerHTML = menuIconOpen;
  document.querySelectorAll('main, footer').forEach(el => { el.inert = false; });
  document.removeEventListener('keydown', menuKeydown);
  document.removeEventListener('click', menuOutsideClick, true);
  menuLastFocused?.focus();
}
menuToggle && menuToggle.addEventListener('click', () => {
  navLinks?.classList.contains('open') ? closeMobileMenu() : openMobileMenu();
});
navLinks?.querySelectorAll('a').forEach(a => a.addEventListener('click', closeMobileMenu));

// PDP gallery (thumbs + arrows to cycle the main image)
const pdpMainImg = document.getElementById('pdpMainImg');
const pdpThumbs = Array.from(document.querySelectorAll('.pdp-thumb:not(.placeholder)'));
if(pdpMainImg && pdpThumbs.length){
  const pdpPrev = document.getElementById('pdpPrev');
  const pdpNext = document.getElementById('pdpNext');
  const pdpStatus = document.getElementById('pdpGalleryStatus');
  let pdpIndex = 0;

  function pdpGoTo(index){
    pdpIndex = (index + pdpThumbs.length) % pdpThumbs.length;
    const thumb = pdpThumbs[pdpIndex];
    const img = thumb.querySelector('img');
    if(!img) return;
    pdpMainImg.src = img.src;
    pdpMainImg.alt = img.alt;
    pdpThumbs.forEach((t, i)=>{
      const active = i === pdpIndex;
      t.classList.toggle('active', active);
      if(active) t.setAttribute('aria-current', 'true');
      else t.removeAttribute('aria-current');
    });
    if(pdpStatus) pdpStatus.textContent = `Image ${pdpIndex + 1} of ${pdpThumbs.length}: ${img.alt}`;
  }

  pdpThumbs.forEach((thumb, i)=> thumb.addEventListener('click', ()=> pdpGoTo(i)));
  pdpPrev?.addEventListener('click', ()=> pdpGoTo(pdpIndex - 1));
  pdpNext?.addEventListener('click', ()=> pdpGoTo(pdpIndex + 1));
}

// cookie consent banner
const cookieBanner = document.getElementById('cookieBanner');
if(cookieBanner){
  const COOKIE_KEY = 'grainshift_cookie_consent';
  let cookieConsent = null;
  try{ cookieConsent = localStorage.getItem(COOKIE_KEY); }catch(e){}
  if(!cookieConsent){
    cookieBanner.hidden = false;
    requestAnimationFrame(()=> cookieBanner.classList.add('show'));
  }
  function setCookieConsent(value){
    try{ localStorage.setItem(COOKIE_KEY, value); }catch(e){}
    cookieBanner.classList.remove('show');
    setTimeout(()=>{ cookieBanner.hidden = true; }, 350);
  }
  document.getElementById('cookieAccept')?.addEventListener('click', ()=> setCookieConsent('accepted'));
  document.getElementById('cookieDecline')?.addEventListener('click', ()=> setCookieConsent('declined'));
}

// toast helper
const toast = document.getElementById('toast');
const toastText = document.getElementById('toastText');
function showToast(msg){
  if(!toast) return;
  toastText.textContent = msg;
  toast.classList.add('show');
  clearTimeout(window.__t);
  window.__t = setTimeout(()=> toast.classList.remove('show'), 3400);
}

// newsletter form (Shopify customer list via native /contact#newsletter would be the real hookup;
// kept as a lightweight client-side acknowledgement here, same as before)
const newsletterForm = document.getElementById('newsletterForm');
newsletterForm && newsletterForm.addEventListener('submit', (e)=>{
  e.preventDefault();
  showToast("You're on the list.");
  e.target.reset();
});

/* ---------- FAQ / accordion (accessible: real buttons, aria-expanded) ---------- */
document.querySelectorAll('.faq-item').forEach(item=>{
  const q = item.querySelector('.faq-q');
  if(!q) return;
  q.addEventListener('click', ()=>{
    const isOpen = item.classList.contains('open');
    const group = item.closest('.faq, .pdp-accordion');
    group && group.querySelectorAll('.faq-item.open').forEach(o=>{
      o.classList.remove('open');
      o.querySelector('.faq-q')?.setAttribute('aria-expanded', 'false');
    });
    if(!isOpen){
      item.classList.add('open');
      q.setAttribute('aria-expanded', 'true');
    }
  });
});

// reveal on scroll
const io = new IntersectionObserver((entries)=>{
  entries.forEach(e=>{
    if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); }
  });
}, {threshold:0, rootMargin:'0px 0px -5% 0px'});
document.querySelectorAll('.reveal').forEach(el=> io.observe(el));

/* ---------- Cart: real Shopify AJAX Cart API (/cart/add.js, /cart/change.js, /cart.js) ---------- */
function formatMoney(cents){
  return '$' + (cents / 100).toFixed(2);
}
function renderCart(cart){
  const countEl = document.getElementById('cartCount');
  if(countEl){
    countEl.textContent = String(cart.item_count);
    countEl.hidden = cart.item_count === 0;
  }
  const itemsEl = document.getElementById('cartItems');
  if(itemsEl){
    if(cart.items.length === 0){
      itemsEl.innerHTML = '<p class="cart-empty">Your cart is empty.</p>';
    } else {
      itemsEl.innerHTML = cart.items.map(l => (
        '<div class="cart-line">' +
          '<div class="cl-info">' +
            '<div class="cl-label">' + l.product_title + (l.variant_title ? ' — ' + l.variant_title : '') + (l.quantity > 1 ? ' × ' + l.quantity : '') + '</div>' +
            '<button class="cl-remove" data-remove-key="' + l.key + '">Remove</button>' +
          '</div>' +
          '<div class="cl-price">' + formatMoney(l.final_line_price) + '</div>' +
        '</div>'
      )).join('');
      itemsEl.querySelectorAll('[data-remove-key]').forEach(btn=>{
        btn.addEventListener('click', ()=> changeLine(btn.dataset.removeKey, 0));
      });
    }
  }
  const subtotalEl = document.getElementById('cartSubtotal');
  if(subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
  const checkoutBtn = document.getElementById('cartCheckoutBtn');
  if(checkoutBtn){
    if(cart.item_count === 0){
      checkoutBtn.setAttribute('aria-disabled', 'true');
      checkoutBtn.classList.add('btn-disabled-look');
    } else {
      checkoutBtn.removeAttribute('aria-disabled');
      checkoutBtn.classList.remove('btn-disabled-look');
    }
  }
}
async function fetchCart(){
  const res = await fetch('/cart.js');
  const cart = await res.json();
  renderCart(cart);
  return cart;
}
async function addToCart(variantId, quantity){
  quantity = quantity || 1;
  const res = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({items: [{id: variantId, quantity: quantity}]})
  });
  if(!res.ok){
    showToast('Could not add that to your cart.');
    return null;
  }
  await fetchCart();
  return true;
}
async function changeLine(key, quantity){
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({id: key, quantity: quantity})
  });
  fetchCart();
}
let cartLastFocused = null;
function getFocusable(container){
  return Array.from(container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'))
    .filter(el => el.offsetParent !== null);
}
function cartKeydown(e){
  const drawer = document.getElementById('cartDrawer');
  if(!drawer) return;
  if(e.key === 'Escape'){ e.preventDefault(); closeCart(); return; }
  if(e.key !== 'Tab') return;
  const focusable = getFocusable(drawer);
  if(!focusable.length) return;
  const first = focusable[0], last = focusable[focusable.length - 1];
  if(e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
  else if(!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
}
function openCart(){
  cartLastFocused = document.activeElement;
  document.getElementById('cartDrawer')?.classList.add('open');
  document.getElementById('cartOverlay')?.classList.add('open');
  document.querySelectorAll('header, main, footer').forEach(el => { el.inert = true; });
  document.addEventListener('keydown', cartKeydown);
  const drawer = document.getElementById('cartDrawer');
  const focusable = drawer ? getFocusable(drawer) : [];
  (focusable[0] || drawer)?.focus();
}
function closeCart(){
  document.getElementById('cartDrawer')?.classList.remove('open');
  document.getElementById('cartOverlay')?.classList.remove('open');
  document.querySelectorAll('header, main, footer').forEach(el => { el.inert = false; });
  document.removeEventListener('keydown', cartKeydown);
  cartLastFocused?.focus();
}
document.getElementById('cartToggle')?.addEventListener('click', ()=>{ openCart(); fetchCart(); });
document.getElementById('cartClose')?.addEventListener('click', closeCart);
document.getElementById('cartOverlay')?.addEventListener('click', closeCart);
fetchCart();

/* ---------- PDP: bundle selector (real Shopify variants) ---------- */
let selectedVariantId = null;
let selectedVariantPrice = null;
function applyBundlePrice(radio){
  selectedVariantId = radio.value;
  selectedVariantPrice = parseInt(radio.dataset.price, 10);
  const pdpPriceEl = document.getElementById('pdpPrice');
  const addBtn = document.getElementById('pdpAddToCart');
  const priceStr = formatMoney(selectedVariantPrice);
  if(pdpPriceEl) pdpPriceEl.textContent = priceStr;
  if(addBtn) addBtn.textContent = 'Add to Cart · ' + priceStr;
}
const bundleRadios = document.querySelectorAll('input[name="bundle"]');
bundleRadios.forEach(radio=>{
  radio.addEventListener('change', ()=>{
    if(radio.checked) applyBundlePrice(radio);
  });
});
if(bundleRadios.length){
  const checked = document.querySelector('input[name="bundle"]:checked') || bundleRadios[0];
  applyBundlePrice(checked);
}

document.getElementById('pdpAddToCart')?.addEventListener('click', async ()=>{
  if(!selectedVariantId) return;
  const btn = document.getElementById('pdpAddToCart');
  const originalText = btn.textContent;
  btn.disabled = true;
  btn.textContent = 'Adding…';
  const ok = await addToCart(selectedVariantId, 1);
  btn.disabled = false;
  btn.textContent = originalText;
  if(ok){
    openCart();
    showToast('Added to cart.');
  }
});

document.getElementById('navShopBtn')?.addEventListener('click', ()=>{
  document.querySelector('.option-block')?.scrollIntoView({behavior:'smooth', block:'center'});
});

/* ---------- Reviews system (client-side only — no reviews app installed) ---------- */
const REVIEWS = window.GRAINSHIFT_REVIEWS || [];
let productVisibleCount = 6;
let homeVisibleCount = 6;

function escapeHTML(str){
  return String(str).replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
}
function initialsFor(name){
  const parts = String(name).trim().split(/\s+/).filter(Boolean);
  if(parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
}
function reviewCardHTML(r){
  const starStr = '★'.repeat(r.rating) + '☆'.repeat(5 - r.rating);
  const tagClass = r.tag === 'NEW' ? 'new' : '';
  const tagLabel = r.tag === 'NEW' ? '✓ NEW' : '✓ VERIFIED';
  return '<div class="review-card"><div><div class="rc-head"><span class="review-avatar" aria-hidden="true">'+initialsFor(r.name)+'</span><span class="stars">'+starStr+'</span></div><p>'+escapeHTML(r.text)+'</p></div><div class="who"><span>'+escapeHTML(r.name).toUpperCase()+'</span><span class="verified '+tagClass+'">'+tagLabel+'</span></div></div>';
}
function updateRatingSummary(container, avg, dist, total){
  if(!container) return;
  const avgEl = container.querySelector('.rs-avg');
  const starsEl = container.querySelector('.rs-stars');
  const countEl = container.querySelector('.rs-count');
  if(avgEl) avgEl.textContent = total ? avg.toFixed(1) : '–';
  if(starsEl){
    const rounded = Math.round(avg);
    starsEl.textContent = '★'.repeat(rounded) + '☆'.repeat(5-rounded);
  }
  if(countEl) countEl.textContent = total + ' verified reviews';
  container.querySelectorAll('.rating-bar-row').forEach(row=>{
    const star = parseInt(row.dataset.star, 10);
    const count = dist[5-star] || 0;
    const pct = total ? Math.round((count/total)*100) : 0;
    row.querySelector('.fill').style.width = pct + '%';
    row.querySelector('.pct').textContent = pct + '%';
  });
}
function renderHomeReviews(){
  const grid = document.getElementById('homeReviewGrid');
  if(!grid) return;
  grid.innerHTML = REVIEWS.slice(0, homeVisibleCount).map(reviewCardHTML).join('');
  const btn = document.getElementById('homeReadAllBtn');
  if(btn){
    if(homeVisibleCount >= REVIEWS.length){
      btn.style.display = 'none';
    } else {
      btn.style.display = 'inline-flex';
      btn.textContent = 'Read all ' + REVIEWS.length + ' reviews';
    }
  }
}
function renderProductReviews(){
  const grid = document.getElementById('productReviewGrid');
  if(!grid) return;
  grid.innerHTML = REVIEWS.slice(0, productVisibleCount).map(reviewCardHTML).join('');
  const loadMoreBtn = document.getElementById('loadMoreReviews');
  if(loadMoreBtn){
    if(productVisibleCount >= REVIEWS.length){
      loadMoreBtn.style.display = 'none';
    } else {
      loadMoreBtn.style.display = 'inline-flex';
      loadMoreBtn.textContent = 'Load More Reviews (' + (REVIEWS.length - productVisibleCount) + ' more)';
    }
  }
}
function refreshReviews(){
  const total = REVIEWS.length;
  const avg = total ? REVIEWS.reduce((s,r)=>s+r.rating,0)/total : 0;
  const dist = [5,4,3,2,1].map(s => REVIEWS.filter(r=>r.rating===s).length);
  updateRatingSummary(document.getElementById('ratingSummaryHome'), avg, dist, total);
  updateRatingSummary(document.getElementById('ratingSummaryProduct'), avg, dist, total);
  updateRatingSummary(document.getElementById('ratingSummaryCart'), avg, dist, total);
  const pdpLink = document.getElementById('pdpRatingLink');
  if(pdpLink) pdpLink.textContent = (total ? avg.toFixed(1) : '–') + ' · ' + total + ' verified reviews';
  renderHomeReviews();
  renderProductReviews();
}
document.getElementById('loadMoreReviews')?.addEventListener('click', ()=>{
  productVisibleCount = Math.min(REVIEWS.length, productVisibleCount + 6);
  renderProductReviews();
});
document.getElementById('homeReadAllBtn')?.addEventListener('click', ()=>{
  homeVisibleCount = REVIEWS.length;
  renderHomeReviews();
});
refreshReviews();

/* ---------- Testimonial carousels (click-through, dots + optional arrows) ----------
   Slides stay in normal flow (grid-stacked in CSS) and are switched via opacity,
   not `hidden`/display, so the container never changes height between slides.
   `go()` is the single source of truth for which slide is active — called once
   at setup so JS state and the DOM can't drift apart (see 0/`index` at init). */
function initCarousel({root, slideSelector, dotsContainer, prevBtn, nextBtn, statusEl, label}){
  if(!root) return;
  const slides = root.querySelectorAll(slideSelector);
  if(!slides.length) return;
  let index = 0;
  const dots = [];
  if(dotsContainer){
    dotsContainer.innerHTML = '';
    slides.forEach((_, i)=>{
      const b = document.createElement('button');
      b.className = 'dot';
      b.type = 'button';
      b.setAttribute('aria-label', 'Show testimonial ' + (i + 1) + ' of ' + slides.length);
      b.addEventListener('click', ()=> go(i));
      dotsContainer.appendChild(b);
      dots.push(b);
    });
  }
  function go(i){
    index = (i + slides.length) % slides.length;
    slides.forEach((s, si)=>{
      const active = si === index;
      s.classList.toggle('is-active', active);
      s.setAttribute('aria-hidden', active ? 'false' : 'true');
    });
    dots.forEach((d, di)=>{
      const active = di === index;
      d.classList.toggle('is-active', active);
      d.setAttribute('aria-current', active ? 'true' : 'false');
    });
    if(statusEl){
      const name = slides[index].querySelector('.name')?.textContent || '';
      statusEl.textContent = (label || 'Testimonial') + ' ' + (index + 1) + ' of ' + slides.length + (name ? ', ' + name : '');
    }
  }
  prevBtn?.addEventListener('click', ()=> go(index - 1));
  nextBtn?.addEventListener('click', ()=> go(index + 1));
  go(0);
}
initCarousel({
  root: document.getElementById('testimonialTrack'),
  slideSelector: '.testimonial-slide',
  dotsContainer: document.getElementById('testimonialDots'),
  prevBtn: document.getElementById('tPrev'),
  nextBtn: document.getElementById('tNext'),
  statusEl: document.getElementById('testimonialStatus'),
  label: 'Testimonial'
});
initCarousel({
  root: document.getElementById('miniCarousel'),
  slideSelector: '.mini-slide',
  dotsContainer: document.getElementById('miniCarouselDots'),
  prevBtn: document.getElementById('miniPrev'),
  nextBtn: document.getElementById('miniNext'),
  statusEl: document.getElementById('miniCarouselStatus'),
  label: 'Testimonial'
});

/* ---------- Write a review (demo only, no reviews app installed) ---------- */
document.getElementById('toggleReviewForm')?.addEventListener('click', (e)=>{
  const f = document.getElementById('reviewForm');
  f.hidden = !f.hidden;
  e.target.setAttribute('aria-expanded', String(!f.hidden));
});
document.getElementById('rfCancel')?.addEventListener('click', ()=>{
  document.getElementById('reviewForm').hidden = true;
  document.getElementById('toggleReviewForm')?.setAttribute('aria-expanded', 'false');
});
document.getElementById('rfSubmit')?.addEventListener('click', (e)=>{
  e.preventDefault();
  const name = document.getElementById('rfName').value.trim();
  const text = document.getElementById('rfText').value.trim();
  const ratingInput = document.querySelector('input[name="rfRating"]:checked');
  const rating = ratingInput ? parseInt(ratingInput.value, 10) : 0;
  const errEl = document.getElementById('rfError');
  if(!name || !text || !rating){
    errEl.textContent = 'Please add your name, a star rating, and a short review.';
    errEl.hidden = false;
    return;
  }
  errEl.hidden = true;
  REVIEWS.unshift({name, rating, text, tag:'NEW'});
  productVisibleCount = Math.max(productVisibleCount, 6);
  refreshReviews();
  document.getElementById('rfName').value = '';
  document.getElementById('rfText').value = '';
  if(ratingInput) ratingInput.checked = false;
  document.getElementById('reviewForm').hidden = true;
  document.getElementById('toggleReviewForm')?.setAttribute('aria-expanded', 'false');
  showToast("Thanks. Your review has been posted.");
});
